module.exports = __webpack_public_path__ + "static/logo-africoin-eb94a9d04bb330bfd34f149ce3eee58f.svg";